import React from "react";
import { Link } from "react-router-dom";

export default function CtaSection() {
  return (
    <section className="bg-indigo-600 py-16 dark:bg-indigo-700 sm:py-20">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6 lg:px-8">
        <h2 className="text-2xl font-bold tracking-tight text-white sm:text-3xl lg:text-4xl">
          Ready to simplify your rent collection?
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-lg text-indigo-100">
          Join hundreds of landlords who have already switched to Paysafi.
          Set up your first property in under 3 minutes.
        </p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/signup"
            className="inline-flex items-center justify-center rounded-lg bg-white px-6 py-3 text-base font-semibold text-indigo-600 transition-colors duration-150 hover:bg-indigo-50"
          >
            Get started
          </Link>
          <Link
            to="/contact"
            className="inline-flex items-center justify-center rounded-lg border border-indigo-400 px-6 py-3 text-base font-semibold text-white transition-colors duration-150 hover:bg-indigo-700 dark:hover:bg-indigo-800"
          >
            Talk to us
          </Link>
        </div>
      </div>
    </section>
  );
}
